import React from "react";
import LMS from "./LMS";
import noActivity from "../images/no-activity-found.svg";

export const NoActivityFound = props => {
  return (
    <div className="t-container-fluid t-row activity_list__no_activity_found_container">
      <div className="offset-md-3 t-col-md-2 t-col-sm-4">
        <img style={{ width: "100%", display: "block" }} src={noActivity} alt="" />
      </div>
      <div className="t-col-md-4 t-col-sm-8">
        <h4>No activity found</h4>
        <p>Try selecting some other filters.</p>

        <div className="no_activity_found__send_enquiry__container">
          <p>Looking for something specific?</p>
          <LMS />
        </div>
      </div>
    </div>
  );
};

export const NoMoreActivityLeft = props => {
  return (
    <div className="t-container-fluid t-row activity_list__no_activity_found_container activity_list__no_more_activity_left_container">
      <div className="t-col-12 center__align">
        <h4>No more options available.</h4>
        <p>Looking for something specific?</p>
        <LMS />
      </div>
    </div>
  );
};
